import StudentIdListTable from './StudentIdListTable';

export default StudentIdListTable;
